export const BEST_TYPE_NAME = 'BEST';
export const WORST_TYPE_NAME = 'WORST';
